import { useEffect, useMemo } from 'react';

import type { LunaClient } from '@vlabs/api-bindings';
import { apiContainer } from '@vlabs/api-bindings';
import qs from 'qs';
import { useHistory, useLocation } from 'react-router-dom';

function AuthTokenPage(): null {
  const history = useHistory();
  const { search } = useLocation();
  const token = useMemo(() => {
    const query = qs.parse(search, { ignoreQueryPrefix: true });
    return query.token;
  }, [search]);

  useEffect(() => {
    if (!token) {
      history.push('/');
    }

    (apiContainer.lunaClient as LunaClient).login.login({ token })
      .then(() => {
        history.push('/');
        window.location.reload();
      })
      .catch(() => {
        history.push('/');
      });
  }, [token, history]);

  return null;
}

export { AuthTokenPage };
